import PropTypes from 'prop-types';
import { graphql, useFragment } from 'react-relay';

// components
import { SbSharedRefineMenuMultiSelectList } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectList.jsx';

const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuFilterMatchingSets_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuMultiSelectList_itemSearch
    }
`;

export const SbSharedRefineMenuFilterMatchingSets = ({
    itemSearch: itemSearchRef,
    values,
    filterName,
    collapsedItemCount,
    shouldUseExpandableList,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    return (
        <SbSharedRefineMenuMultiSelectList
            itemSearch={itemSearch}
            values={values}
            filterName={filterName}
            collapsedItemCount={collapsedItemCount}
            shouldUseExpandableList={shouldUseExpandableList}
        />
    );
};

SbSharedRefineMenuFilterMatchingSets.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    values: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
    collapsedItemCount: PropTypes.number,
    shouldUseExpandableList: PropTypes.bool,
};
